import { render, staticRenderFns } from "./file-store-picker.vue?vue&type=template&id=2bc6aa86"
import script from "./file-store-picker.vue?vue&type=script&lang=js"
export * from "./file-store-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports